<a class="banner-link" (click)="handleCookieLinkClick()" (keypress.enter)="handleCookieLinkClick()" href="{{ link }}"
    >{{ linkLabel }}.</a
>
